<template lang="pug">

  .course-points-shop-popup(@click.self="closePopup")
    .course-points-shop-confirm(@click.self="closePopup")
      Icon.course-points-shop-product__close(
        icon="aside-close"
        @click="closePopup"
      )
      p.course-points-shop-confirm__description
        | Как использовать промокод?

      p.course-points-shop-confirm__subdescription
        | После покупки промокода за бонусы необходимо
        | перейти на&nbsp;
        a(href="https://likecentre.ru/toolbox-lms-shop" target="_blank" alt="") https://likecentre.ru/toolbox-lms-shop
        br
        |  Выбери нужный продукт и введите свой промокод.

</template>

<script>
export default {
  methods: {
    closePopup() {
      this.$store.dispatch('coursePointsShop/setMeta', {
        path: 'shopPromoPopup',
        value: false
      });
    }
  }
};
</script>
